var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PieVisual',{attrs:{"progress":_vm.progress,"x":_vm.centerX,"y":_vm.centerY,"r":_vm.radius,"fillColor":_vm.fillColor}})}
var staticRenderFns = []

export { render, staticRenderFns }